<div class="aig-claimsState u-my-8 container u-minheight-vh-80">
  <div class="row">
    <div class="col-12">
      <aig-breadcrumb [config]="[
        { title: 'Área de cliente', link: '/area-cliente' },
        { title: 'Gestión de siniestros', link: '/area-cliente/gestion-siniestros' },
        { title: 'Nuevo siniestro', link:'/area-cliente/gestion-siniestros/nuevo' }
]"></aig-breadcrumb>
    </div>
  </div>
  <!-- STEPPER -->
  <mat-stepper [linear]="isLinear" #stepper class="c-stepper">

    <!-- PASO 1 -->
    <mat-step [stepControl]="personalDataForm">
      <h3 class="u-color-primary1 u-fs-40 u-p-8 p-flexcc">Datos personales</h3>

      <form [formGroup]="personalDataForm" class="aig-modifyData__form">
        <ng-template matStepLabel>Datos personales</ng-template>

        <div class="row">

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="nombre">Nombre y Apellidos *</label>
              <input type="text" id="nombre" class="e-field__input" formControlName="nombre" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="dni">DNI/NIE *</label>
              <input type="text" id="dni" class="e-field__input" formControlName="dni" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="telefono">Teléfono de contacto *</label>
              <input type="tel" id="telefono" class="e-field__input" formControlName="telefono" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="email">Email *</label>
              <input type="email" id="email" class="e-field__input" formControlName="email" />
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-12 col-lg-4">
            <div class="e-field">
              <label class="e-field__label" for="direccion">Dirección *</label>
              <input type="text" id="direccion" class="e-field__input" formControlName="direccion" />
            </div>
          </div>

          <div class="col-12 col-lg-2">
            <div class="e-field">
              <label class="e-field__label" for="cp">Código postal *</label>
              <input type="text" id="cp" class="e-field__input" formControlName="cp" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="poblacion">Población *</label>
              <input type="text" id="poblacion" class="e-field__input" formControlName="poblacion" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="provincia">Provincia *</label>
              <input type="text" id="provincia" class="e-field__input" formControlName="provincia" />
            </div>
          </div>

        </div>
        <div class="row p-flexce">
          <div class="p-flexce u-gap-8 col-3 u-mt-4">
            <button mat-button matStepperPrevious class="e-btn--secondary p-flexcc u-size-per-100">Atrás</button>
            <button mat-button matStepperNext class="e-btn--primary p-flexcc u-size-per-100"
              [disabled]="!personalDataForm.valid">Siguiente</button>
          </div>
        </div>
      </form>

      <div class="row">
        <div class="col-12">
          <div class="p-flexcc u-pt-8">
            <p class="u-fs-18 u-fw-400 u-text-center">
              Para cualquier consulta puedes escribirnos a
              <a class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
                href="mailto:backoffice.caixa@icp.es">backoffice.caixa&#64;icp.es
              </a>
            </p>
          </div>
        </div>
      </div>

    </mat-step>

    <!-- PASO 2 -->
    <mat-step [stepControl]="TypeSinisterDataForm">
      <h3 class="u-color-primary1 u-fs-40 u-p-8 p-flexcc">Tipo de siniestro</h3>
      <form [formGroup]="TypeSinisterDataForm">
        <ng-template matStepLabel>Tipo de siniestro</ng-template>

        <div class="row">

          <div class="col-12 col-lg-4">
            <div class="e-field">
              <label class="e-field__label" for="tipoSiniestro">Tipo de siniestro *</label>
              <mat-select class="e-field__input" id="tipoSiniestro" formControlName="tipoSiniestro">
                <mat-option *ngFor="let tipo of tipoSiniestroOptions" [value]="tipo.idTipoExpediente">
                  {{ tipo.tipoExpediente }}
                </mat-option>
              </mat-select>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="e-field">
              <label class="e-field__label" for="tipoCobertura">Tipo de cobertura *</label>
              <mat-select class="e-field__input" id="tipoCobertura" formControlName="tipoCobertura" multiple>
                <mat-option *ngFor="let cobertura of tipoCoberturaOptions" [value]="cobertura.idCobertura">
                  {{ cobertura.cobertura }}
                </mat-option>
              </mat-select>
            </div>
          </div>

        </div>

        <div class="row p-flexce">
          <div class="p-flexce u-gap-8 col-3">
            <button mat-button matStepperPrevious class="e-btn--secondary p-flexcc u-size-per-100">Atrás</button>
            <button class="e-btn--primary p-flexcc u-size-per-100" mat-button matStepperNext
              [disabled]="!TypeSinisterDataForm.valid">Siguiente</button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <div class="p-flexcc u-pt-8">
            <p class="u-fs-18 u-fw-400 u-text-center">
              Para cualquier consulta puedes escribirnos a
              <a class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
                href="mailto:backoffice.caixa@icp.es">backoffice.caixa&#64;icp.es
              </a>
            </p>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- PASO 3 -->
    <mat-step [stepControl]="DataSinisterDataForm">
      <h3 class="u-color-primary1 u-fs-40 u-p-8 p-flexcc">Datos sobre el siniestro</h3>

      <form [formGroup]="DataSinisterDataForm">
        <ng-template matStepLabel>Datos sobre el siniestro</ng-template>

        <div class="row">
          <div class="col-12">
            <div class="e-field">
              <label class="e-field__label" for="tipoSiniestro">Por favor, indique cómo se produjo su siniestro:
                *</label>
              <textarea type="descripcion" id="descripcion" class="e-field__input"
                formControlName="descripcion"></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="lugar">Lugar del suceso *</label>
              <input type="text" id="lugar" class="e-field__input" formControlName="lugar" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="fecha">Fecha del suceso *</label>
              <input type="date" id="fecha" class="e-field__input" formControlName="fecha" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="ciudad">Ciudad *</label>
              <input type="text" id="ciudad" class="e-field__input" formControlName="ciudad" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="pais">Pais *</label>
              <input type="text" id="pais" class="e-field__input" formControlName="pais" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>En caso de que haya algún tipo de dispositivo afectado, completa el siguiente cuestionario: </label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="dispositivo">Tipo de dispositivo</label>
              <input type="text" id="dispositivo" class="e-field__input" formControlName="dispositivo" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="marca">Marca</label>
              <input type="text" id="marca" class="e-field__input" formControlName="marca" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="modelo">Modelo</label>
              <input type="text" id="modelo" class="e-field__input" formControlName="modelo" />
            </div>
          </div>

          <div class="col-12 col-lg-3">
            <div class="e-field">
              <label class="e-field__label" for="nserie">Número de serie</label>
              <input type="text" id="nserie" class="e-field__input" formControlName="nserie" />
            </div>
          </div>
        </div>

        <div class="row p-flexce">
          <div class="p-flexce u-gap-8 col-3">
            <button mat-button matStepperPrevious class="e-btn--secondary p-flexcc u-size-per-100">Atrás</button>
            <button class="e-btn--primary p-flexcc u-size-per-100" mat-button matStepperNext
              [disabled]="!DataSinisterDataForm.valid">Siguiente</button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <div class="p-flexcc u-pt-8">
            <p class="u-fs-18 u-fw-400 u-text-center">
              Para cualquier consulta puedes escribirnos a
              <a class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
                href="mailto:backoffice.caixa@icp.es">backoffice.caixa&#64;icp.es
              </a>
            </p>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- PASO 4 -->
    <mat-step [stepControl]="DocumentationDataForm">
      <h3 class="u-color-primary1 u-fs-40 u-p-8 p-flexcc">Documentación del siniestro</h3>

      <div class="p-flecss u-mb-8">
        <p class="u-fs-16 u-color-secondary1">
          Por favor, adjunta toda la documentación relacionada con tu siniestro. Esto incluye denuncias, facturas o cualquier otro documento que pueda ayudarnos a ofrecerle una respuesta en el menor tiempo posible.
        </p>
        <div class="aig-newClaim__documents u-pt-2">
            <div class="aig-fileupload">
                <label class="" [class.error]="uploadError">
                    <input type="file" multiple (change)="onFileSelected($event)" hidden #fileInput />
                    <div (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                        class=" aig-newClaim__dragcontainer u-p-def">
                        <i class="icon-open-email aig-newClaim__dragcontainer--icon"></i>
                        <p class="aig-newClaim__dragcontainer--txt">Suelta o selecciona los archivos aquí
                        </p>
                    </div>
                </label>

                <div *ngIf="uploadError" class="u-border u-border-warning-error u-radius-4 u-p-def u-my-2">
                    <p class="u-color-warning-error">
                        El archivo '{{ uploadError }}' no se ha cargado correctamente. Inténtalo de nuevo.
                    </p>
                </div>

                <div class="u-border u-border-primary1 u-radius-4 u-p-def u-my-2"
                    *ngFor="let file of uploadedFiles">
                    <div class="p-flexcb">
                        <p class="u-color-secondary1">{{ file.name }}</p>
                        <button class="e-btn--secondary p-2" (click)="removeFile(file)"><i
                                class="icon-trash"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>


      <form [formGroup]="DocumentationDataForm">
        <ng-template matStepLabel>Documentación del siniestro</ng-template>
        <div class="row p-flexce">
          <div class="p-flexce u-gap-8 col-3">
            <button mat-button matStepperPrevious class="e-btn--secondary p-flexcc u-size-per-100">Atrás</button>
            <button class="e-btn--primary p-flexcc u-size-per-100" mat-button (click)="onFinalizarStepper()"
              [disabled]="!DocumentationDataForm.valid">Finalizar </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <div class="p-flexcc u-pt-8">
            <p class="u-fs-18 u-fw-400 u-text-center">
              Para cualquier consulta puedes escribirnos a
              <a class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
                href="mailto:backoffice.caixa@icp.es">backoffice.caixa&#64;icp.es
              </a>
            </p>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- PASO 5 -->
    <mat-step [stepControl]="OKDataForm">
      <h3 class="u-color-primary1 u-fs-40 u-p-8 p-flexcc">¡Hemos registrado tu solicitud!</h3>

        <ng-template matStepLabel>Solicitud registrada</ng-template>
        <div class="row">
          <div class="col-12">
            <div class="p-flexcc u-pb-8">
              <p>Tu solicitud ha sido registrada con éxito. Investigaremos tu siniestro y te daremos una respuesta con
                la mayor
                brevedad posible.</p>
            </div>
          </div>
          <div class="col-12">
            <div class="p-flexcc">
              <p>En caso de que su solicitud sea aprobada y te gestionemos un abono económico, el ingreso lo recibirás
                en la cuenta bancaria vinculada a tu póliza. Si deseas recibir el ingreso en una cuenta bancaria diferente
                podrás modificar los datos bancarios dentro de tu área de clientes.</p>
            </div>
          </div>
          <div class="col-12">
            <div class="p-flexcc u-py-8">
              <p class="u-fs-18 u-fw-400 u-text-center">
                Recuerda que para cualquier consulta puedes escribirnos a
                <a class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
                  href="mailto:backoffice.caixa@icp.es">backoffice.caixa&#64;icp.es
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="row p-flexcc">
          <div class="p-flexcc col-3">
            <button mat-button class="e-btn--primary p-flexcc u-size-per-100" (click)="Comeback()">Volver al área de clientes</button>
          </div>
        </div>

    </mat-step>
  </mat-stepper>

</div>


@if(visibleClientModal){
  <aig-modal-client (titularAnswered)="onTitularAnswered($event)"></aig-modal-client>
  }
